var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#EFF4F1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.167 12.5H15.8337C14.9132 12.5 14.167 13.2462 14.167 14.1667V25.8333C14.167 26.7538 14.9132 27.5 15.8337 27.5H24.167C25.0875 27.5 25.8337 26.7538 25.8337 25.8333V14.1667C25.8337 13.2462 25.0875 12.5 24.167 12.5Z",
  stroke: "#94B4A4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 15.8333H22.5",
  stroke: "#94B4A4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 19.1667H22.5",
  stroke: "#94B4A4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 22.5H20.8333",
  stroke: "#94B4A4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgSearchDiagnosisIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDiagnosisIcon);
export default __webpack_public_path__ + "static/media/search-diagnosis-icon.bf2669b55cf68cc7df7b5a492d1ed0eb.svg";
export { ForwardRef as ReactComponent };